import React from 'react';
import {
  GoogleIc,
  InstagramIc,
  OnlyFansIc,
  TwitterIc,
  GlobalIc,
  IcReddit,
  IcAnotherSoc,
  IcTg,
  IcTikTok,
  IcYoutube,
} from '../components/icons';

export type PlatformType =
  | 'OnlyFans'
  | 'Instagram'
  | 'Twitter'
  | 'Google'
  | 'Reddit'
  | 'TikTok'
  | 'Telegram'
  | 'YouTube'
  | 'Other';

export type PlatformSource =
  | 'only_fans'
  | 'instagram'
  | 'twitter'
  | 'google'
  | 'reddit'
  | 'tiktok'
  | 'telegram'
  | 'youtube'
  | 'another';

/**
 * Получает иконку платформы по источнику
 */
export const getPlatformIcon = (source: string): React.ReactNode => {
  switch (source) {
    case 'instagram':
      return React.createElement(InstagramIc);
    case 'twitter':
      return React.createElement(TwitterIc);
    case 'only_fans':
      return React.createElement(OnlyFansIc);
    case 'google':
      return React.createElement(GoogleIc);
    case 'reddit':
      return React.createElement(IcReddit);
    case 'tiktok':
      return React.createElement(IcTikTok);
    case 'telegram':
      return React.createElement(IcTg);
    case 'youtube':
      return React.createElement(IcYoutube);
    case 'another':
      return React.createElement(IcAnotherSoc);
    default:
      return React.createElement(GoogleIc);
  }
};

/**
 * Получает иконку платформы с настройками для рендера
 */
export const getPlatformIconForRender = (platform: string, className?: string): React.ReactNode => {
  const defaultClassName = className || 'w-4 h-4';

  switch (platform) {
    case 'Instagram':
      return React.createElement(InstagramIc, { className: defaultClassName });
    case 'Twitter':
      return React.createElement(TwitterIc, { className: defaultClassName });
    case 'OnlyFans':
      return React.createElement(OnlyFansIc, { className: defaultClassName });
    case 'Google':
      return React.createElement(GoogleIc, { className: defaultClassName });
    case 'Reddit':
      return React.createElement(IcReddit, { className: defaultClassName });
    case 'TikTok':
      return React.createElement(IcTikTok, { className: defaultClassName });
    case 'Telegram':
      return React.createElement(IcTg, { className: defaultClassName });
    case 'YouTube':
      return React.createElement(IcYoutube, { className: defaultClassName });
    default:
      return React.createElement(GoogleIc, { className: defaultClassName });
  }
};

/**
 * Преобразует источник в читаемое название платформы
 */
export const transformPlatform = (source: string): PlatformType => {
  switch (source) {
    case 'only_fans':
      return 'OnlyFans';
    case 'instagram':
      return 'Instagram';
    case 'twitter':
      return 'Twitter';
    case 'google':
      return 'Google';
    case 'reddit':
      return 'Reddit';
    case 'tiktok':
      return 'TikTok';
    case 'telegram':
      return 'Telegram';
    case 'youtube':
      return 'YouTube';
    case 'another':
      return 'Other';
    default:
      return 'Other';
  }
};

/**
 * Получает иконку для фильтра по источнику
 */
export const getFilterIcon = (
  source: string,
  size: number = 16,
  fill?: string
): React.ReactNode => {
  const props = { size, ...(fill && { fill }) };

  switch (source) {
    case 'all':
      return React.createElement(GlobalIc, props);
    case 'only_fans':
      return React.createElement(OnlyFansIc, props);
    case 'reddit':
      return React.createElement(IcReddit, props);
    case 'instagram':
      return React.createElement(InstagramIc, props);
    case 'tiktok':
      return React.createElement(IcTikTok, props);
    case 'google':
      return React.createElement(GoogleIc, props);
    case 'telegram':
      return React.createElement(IcTg, props);
    case 'twitter':
      return React.createElement(TwitterIc, props);
    case 'youtube':
      return React.createElement(IcYoutube, props);
    case 'another':
      return React.createElement(IcAnotherSoc, props);
    default:
      return React.createElement(GlobalIc, props);
  }
};

/**
 * Проверяет, является ли источник валидной платформой
 */
export const isValidPlatformSource = (source: string): source is PlatformSource => {
  return [
    'only_fans',
    'instagram',
    'twitter',
    'google',
    'reddit',
    'tiktok',
    'telegram',
    'youtube',
    'another',
  ].includes(source);
};

/**
 * Получает список всех доступных источников платформ
 */
export const getAvailablePlatformSources = (): PlatformSource[] => {
  return [
    'only_fans',
    'instagram',
    'twitter',
    'google',
    'reddit',
    'tiktok',
    'telegram',
    'youtube',
    'another',
  ];
};

/**
 * Получает список всех доступных типов платформ
 */
export const getAvailablePlatformTypes = (): PlatformType[] => {
  return [
    'OnlyFans',
    'Instagram',
    'Twitter',
    'Google',
    'Reddit',
    'TikTok',
    'Telegram',
    'YouTube',
    'Other',
  ];
};
